var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.512 0H1.17C.527 0 0 .509 0 1.13v15.74C0 17.49.527 18 1.17 18h13.66c.643 0 1.17-.509 1.17-1.13V5.827L10.512 0zM6.546 8.436V4.785h2.908v3.651h1.67L8 12.206l-3.124-3.77h1.67zm5.215 5.778H4.238V13.17h7.523v1.043z",
    fill: "var(--tru-gunmetal)",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadInvoice);
export default ForwardRef;